import React from 'react';
import { useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES,
  coursePauseRequestedRequestUpdateModalSelector,
} from 'features/courseResume';
import SuccessStage from './SuccessStage';
import UpdateStage from './UpdateStage';

function CoursePauseRequestedRequestUpdateModalStages() {
  const { modalStage } = useSelector(
    coursePauseRequestedRequestUpdateModalSelector
  );

  switch (modalStage) {
    case COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.update:
      return <UpdateStage />;
    case COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.success:
      return <SuccessStage />;
    default:
      return null;
  }
}

export default CoursePauseRequestedRequestUpdateModalStages;
